<template>
	<div
		class="pa-3 white--text subheading pre-wrap overflow-hidden"
		:style="{
			backgroundColor: '#00cbb7',
			height: isFullView ? 'auto' : '200px'
		}"
	>
		{{ text }}
	</div>
</template>

<script>
export default {
	name: "AnalyticsElText",
	props: ["text", "isFullView"],
	methods: {
		// _extractBgColor(obj) {
		// 	if (typeof obj !== "object") return "#000"
		//
		// 	let str = obj.S
		// 	if (typeof str !== "string") return "#000"
		//
		// 	return str.split("_")[0]
		// }
	}
}
</script>

<style lang="scss" scoped>
.pre-wrap {
	white-space: pre-wrap;
	word-break: break-word;
}
</style>
